import { makeStyles, Paper, TextField } from '@material-ui/core';
import { useContext, useState } from 'react';
import { Bold } from '../../components/UI/TextFormatters';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { AvatarTwoTonesAnimated } from '../../components/UI/SVGAssets/SVGAssets';
import { isValidEmail } from '../../utils/MiscellaneousUtils';
import { AppContext } from '../../contexts/AppContext';
import userAPI from '../../services/UserApi';
import { STORAGE } from '../../constants/GlobalConstants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: 'calc(100vh - 150px)',
    rowGap: '1em',
  },
  userWrapper: {
    display: 'flex',
    justifyContent: 'center',
    columnGap: '1em',
  },
  userInfoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  userSettingsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  userSettings: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '1em',
    padding: '2em',
    background: `radial-gradient(at bottom left,${theme.palette.primary.light} 0%, rgba(0, 0, 0, .1) 100%)`,
  },
  loginBtn: {
    marginTop: '1em',
    borderRadius: 10,
  },
}));

const MyAccount = () => {
  const classes = useStyles();
  const { userInfo } = useContext(LoginContext);
  const { showWarning, showError, showSuccess } = useContext(AppContext);
  const [email, setEmail] = useState(userInfo.email);
  const [loading, setLoading] = useState(false);

  const updateUserSettings = () => {
    const request = {
      NewEmail: email,
    };

    userAPI
      .changeUserSettings(request)
      .then(result => {
        STORAGE.set(STORAGE.USER_INFO, { ...userInfo, email: email });
        setLoading(false);
        showSuccess('Los cambios se han actualizado con éxito');
      })
      .catch(error => {
        setLoading(false);
        showError('No se pudo actualizar los datos de usuario');
      });
  };

  const handleSave = () => {
    setLoading(true);
    updateUserSettings();
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = email.isBlank())) {
      errorMessages.push('Debe completar el email del usuario');
    } else if ((errors[i++] = !isValidEmail(email))) {
      errorMessages.push('El email ingresado no es válido');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSave = () => validate() && handleSave();

  return (
    <ViewPortGridWrapper>
      <div className={classes.root}>
        <div className={classes.userSettingsWrapper}>
          <Paper className={classes.userSettings} elevation={10}>
            <div className={classes.userWrapper}>
              <AvatarTwoTonesAnimated />
              <div className={classes.userInfoWrapper}>
                <div>{userInfo.name}</div>
                <div>
                  <Bold>{userInfo.role.toTitleCase()}</Bold>
                </div>
              </div>
            </div>
            <TextField
              style={{ width: '30em' }}
              margin="dense"
              id="email"
              label="Email"
              onChange={e => setEmail(e.target.value)}
              value={email}
            />
            <AnimatedButton className={classes.loginBtn} variant="contained" color="primary" onClick={validateAndSave} loading={loading}>
              Guardar
            </AnimatedButton>
          </Paper>
        </div>
      </div>
    </ViewPortGridWrapper>
  );
};

export default MyAccount;
